
/// <amd-module name="TFS/Admin/Common/Constants/Constants" />
export const aadPrefix = "aad";
export const aadspPrefix = "aadsp";
export const TeamProjectDomainPrefix = "vstfs:///Classification/TeamProject";

export const enum ServiceInstanceTypes {
    AEX = "00000041-0000-8888-8000-000000000000",
    Users = "00000038-0000-8888-8000-000000000000",
    SPS = "951917ac-a960-4999-8464-e3f0aa25b381"
}

export enum IEntityType {
    User = "user",
    Group = "group",
    Custom = "custom",
    Vsd = "vsd"
}

export namespace Routes {
    export const OrganisationSettingsRouteId: string = "ms.vss-admin-web.collection-admin-hub-route";
    export const ProjectSettingsRouteId: string = "ms.vss-admin-web.project-admin-hub-route";
}

export namespace AdminHubViewKeys {
    export const OrganisationGroups: string = "groups";
    export const ProjectGroups: string = "permissions";
    export const TeamGroups: string = "teams";
}

export namespace QueryParams {
    export const AdminPivot: string = "adminPivot";
    export const SubjectDescriptor = "subjectDescriptor";
    export const Project: string = "project";
}

export const ims = "ims";
export const aad = "aad";
export const source = "source";
export const user = "user";
export const group = "group";
export const servicePrincipal = "servicePrincipal";
export const aadGroup = "aadGroup";

export const minResults = 5;
export const maxResults = 20;

export const defaultIndex = 0;
export const firstIndex = 1;

export interface IOperationStatus {
    name: string;
    value: string | Result;
    message: string;
}

export enum Result {
    Success,
    Partial,
    Failed
}
